import type { FetchFunction } from '#layers/base/public';
import { createStore } from '@rstore/vue';
import { createMonospacePlugin } from './plugins/2.monospace';
import { createSystemSchema } from './schema/system';

declare module '#layers/runtime/entity-store/registry' {
	interface SystemEntityStoreRegistry {
		store: Awaited<ReturnType<typeof createSystemRStore>>;
	}
}

export async function createSystemRStore(fetch: FetchFunction) {
	return await createStore({
		experimentalGarbageCollection: true,
		plugins: [createMonospacePlugin(fetch)],
		schema: createSystemSchema(fetch),
	});
}
